export default "__VITE_ASSET__CaGZIIkr__"